import {
  BooleanField,
  FuzzyField,
  NumberField,
  SelectField,
  TextField,
  useStudioForm,
} from "~/components/Form";
import { FiltersSidebar, withoutBaseTableModel } from "~/components/Table";
import { CommonFilters } from "~/domain/common";
import { LogSelect, processStateOptions, WorkflowSelect } from "~/lqs";
import { listDigestionsSchema } from "../schemas";
import { useDigestionSearchRequest } from "./DigestionTable";

export function DigestionFilters() {
  const [request, setRequest] = useDigestionSearchRequest();

  const { control, handleSubmit } = useStudioForm({
    schema: listDigestionsSchema,
    values: withoutBaseTableModel(request),
    onSubmit: setRequest,
  });

  return (
    <FiltersSidebar handleSubmit={handleSubmit}>
      <TextField control={control} name="id" />
      <FuzzyField control={control} exactName="name" fuzzyName="nameLike" />
      <LogSelect control={control} name="logId" />
      <WorkflowSelect control={control} name="workflowId" />
      <BooleanField control={control} name="workflowIdNull" />
      <SelectField
        control={control}
        name="state"
        options={processStateOptions}
      />
      <TextField control={control} name="noteLike" label="Note" />
      <NumberField control={control} name="progressGte" />
      <NumberField control={control} name="progressLte" />
      <BooleanField control={control} name="progressNull" />
      <CommonFilters control={control} />
    </FiltersSidebar>
  );
}
